<div
  *ngIf="isInit"
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  aria-labelledby="add-reservation-modal-title"
  role="dialog"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head01 c-add-reservation-modal__head">
      <h1
        id="add-reservation-modal-title"
        class="p-modal-head01__title c-add-reservation-modal__head--title"
        [innerHTML]="'label.addOtherReservation' | staticMsg"
      ></h1>
      <button id="add-reservation-modal-h2" class="p-modal-head01__close js-wModal-close" (click)="clickClose()">
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>
  <div #modalBody [class]="lmodalBodyClass">
    <div class="p-modal-body06">
      <div class="p-add-other-reserve">
        <div class="p-add-other-reserve__head">
          <div class="p-add-other-reserve__title p-add-other-reserve__title--em">
            <span class="c-text-with-tooltip">
              <span class="c-text-with-tooltip__text">{{ 'label.searchTarget.withNoTag1' | staticMsg }}</span>
              <span class="c-text-with-tooltip__tooltip js-tooltip">
                <asw-tooltip
                  iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
                    'm_static_message-alt.helpIcon2' | staticMsg
                  }} width=&quot;20&quot; height=&quot;20&quot;>"
                  [tooltipContent]="'tooltip.aboutReservationSearch' | staticMsg"
                  tooltipDisplayType="tap"
                  [tooltipTop]="-55"
                  [displayAreaClass]="'p-modal-body06'"
                ></asw-tooltip>
              </span>
            </span>
          </div>
          <fieldset class="c-radio-list02" role="radiogroup" aria-invalid="false">
            <legend class="c-radio-list02__legend">{{ 'label.searchTarget.withNoTag1' | staticMsg }}</legend>
            <div class="c-radio-list02__wrap">
              <asw-radiobutton-box
                [text]="reservationList"
                [(selectedItem)]="selectedItem"
                [(value)]="selectItemValue"
              ></asw-radiobutton-box>
            </div>
          </fieldset>
        </div>
        <ng-container *ngIf="selectItemValue === 0">
          <asw-alert-area [isModal]="true"></asw-alert-area>
          <form [formGroup]="reservationNumberForm">
            <div class="p-add-other-reserve__body">
              <div class="p-add-other-reserve__row">
                <!-- 1.3 予約番号 -->
                <div class="p-add-other-reserve__row-item">
                  <div class="p-add-other-reserve__box">
                    <asw-input
                      label="{{ 'label.recLoc' | staticMsg }}"
                      formControlName="reservationNumber"
                      required
                      attr.aria-describedBy="{{ 'reader.reservationNumber' | staticMsg }}"
                      placeholder="{{ 'placeholder.recLoc' | staticMsg }}"
                    ></asw-input>
                  </div>
                </div>
                <!-- 1.3 搭乗者(名) -->
                <div class="p-add-other-reserve__row-item">
                  <div class="p-add-other-reserve__box">
                    <asw-input
                      label="{{ 'label.passengerName' | staticMsg }}"
                      formControlName="firstName"
                      conversionType="paxName"
                      required
                      attr.aria-describedBy="{{ 'reader.passengerName' | staticMsg }}"
                      placeholder="{{ 'placeholder.passengerName' | staticMsg }}"
                    ></asw-input>
                  </div>
                  <div class="p-add-other-reserve__row-item-summary">
                    <span class="c-text-with-tooltip">
                      <span
                        class="c-text-with-tooltip__text"
                        [innerHTML]="'tooltip.aboutReservationName' | staticMsg"
                      ></span>
                      <span class="c-text-with-tooltip__tooltip js-tooltip">
                        <asw-tooltip
                          iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
                            'm_static_message-alt.helpIcon2' | staticMsg
                          }} width=&quot;20&quot; height=&quot;20&quot;>"
                          [tooltipContent]="'tooltip.aboutReservationName' | staticMsg"
                          [displayAreaClass]="'p-modal-body06'"
                        ></asw-tooltip>
                      </span>
                    </span>
                  </div>
                </div>
                <!-- 1.3 搭乗者(姓) -->
                <div class="p-add-other-reserve__row-item">
                  <div class="p-add-other-reserve__box">
                    <asw-input
                      label="{{ 'label.passengerLastName' | staticMsg }}"
                      formControlName="lastName"
                      required
                      conversionType="paxName"
                      attr.aria-describedBy="{{ 'reader.passengerLastName' | staticMsg }}"
                      placeholder="{{ 'placeholder.passengerLastName' | staticMsg }}"
                    ></asw-input>
                  </div>
                  <div class="p-add-other-reserve__row-item-summary">
                    <span class="c-text-with-tooltip">
                      <span
                        class="c-text-with-tooltip__text"
                        [innerHTML]="'tooltip.aboutReservationName' | staticMsg"
                      ></span>
                      <span class="c-text-with-tooltip__tooltip js-tooltip">
                        <asw-tooltip
                          iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
                            'm_static_message-alt.helpIcon2' | staticMsg
                          }} width=&quot;20&quot; height=&quot;20&quot;>"
                          [tooltipContent]="'tooltip.aboutReservationName' | staticMsg"
                          [displayAreaClass]="'p-modal-body06'"
                        ></asw-tooltip>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="p-add-other-reserve__row-item">
                  <div class="p-add-other-reserve__btn">
                    <asw-button
                      id="c-add-reservation-modal__footer--button"
                      type="primary"
                      size="s-min-w100"
                      [label]="'label.link' | staticMsg"
                      (click$)="onLink()"
                    ></asw-button>
                  </div>
                </div>
              </div>
            </div></form
        ></ng-container>
        <ng-container *ngIf="selectItemValue === 1">
          <asw-alert-area [isModal]="true"></asw-alert-area>
          <form [formGroup]="eTicketNumberForm">
            <div class="p-add-other-reserve__body">
              <div class="p-add-other-reserve__row">
                <!-- 1.3 航空券番号 -->
                <div class="p-add-other-reserve__row-item">
                  <div class="p-add-other-reserve__box">
                    <asw-input
                      label="{{ 'label.eTicketNumber' | staticMsg }}"
                      formControlName="ticketNumber"
                      required
                      attr.aria-describedBy="{{ 'reader.eTicketNumber' | staticMsg }}"
                      placeholder="{{ 'placeholder.eTicketNumber' | staticMsg }}"
                    ></asw-input>
                  </div>
                </div>
                <!-- 1.3 搭乗者(名) -->
                <div class="p-add-other-reserve__row-item">
                  <div class="p-add-other-reserve__box">
                    <asw-input
                      label="{{ 'label.passengerName' | staticMsg }}"
                      formControlName="firstName"
                      conversionType="paxName"
                      required
                      attr.aria-describedBy="{{ 'reader.passengerName' | staticMsg }}"
                      placeholder="{{ 'placeholder.passengerName' | staticMsg }}"
                    ></asw-input>
                  </div>
                  <div class="p-add-other-reserve__row-item-summary">
                    <span class="c-text-with-tooltip">
                      <span
                        class="c-text-with-tooltip__text"
                        [innerHTML]="'tooltip.aboutReservationName' | staticMsg"
                      ></span>
                      <span class="c-text-with-tooltip__tooltip js-tooltip">
                        <asw-tooltip
                          iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
                            'm_static_message-alt.helpIcon2' | staticMsg
                          }} width=&quot;20&quot; height=&quot;20&quot;>"
                          [tooltipContent]="'tooltip.aboutReservationName' | staticMsg"
                          [displayAreaClass]="'p-modal-body06'"
                        ></asw-tooltip>
                      </span>
                    </span>
                  </div>
                </div>
                <!-- 1.3 搭乗者(姓) -->
                <div class="p-add-other-reserve__row-item">
                  <div class="p-add-other-reserve__box">
                    <asw-input
                      label="{{ 'label.passengerLastName' | staticMsg }}"
                      formControlName="lastName"
                      required
                      conversionType="paxName"
                      attr.aria-describedBy="{{ 'reader.passengerLastName' | staticMsg }}"
                      placeholder="{{ 'placeholder.passengerLastName' | staticMsg }}"
                    ></asw-input>
                  </div>
                  <div class="p-add-other-reserve__row-item-summary">
                    <span class="c-text-with-tooltip">
                      <span
                        class="c-text-with-tooltip__text"
                        [innerHTML]="'tooltip.aboutReservationName' | staticMsg"
                      ></span>
                      <span class="c-text-with-tooltip__tooltip js-tooltip">
                        <asw-tooltip
                          iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
                            'm_static_message-alt.helpIcon2' | staticMsg
                          }} width=&quot;20&quot; height=&quot;20&quot;>"
                          [tooltipContent]="'tooltip.aboutReservationName' | staticMsg"
                          [displayAreaClass]="'p-modal-body06'"
                        ></asw-tooltip>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="p-add-other-reserve__row-item">
                  <div class="p-add-other-reserve__btn">
                    <asw-button
                      id="c-add-reservation-modal__footer--button"
                      type="primary"
                      size="s-min-w100"
                      [label]="'label.link' | staticMsg"
                      (click$)="onLink()"
                    ></asw-button>
                  </div>
                </div>
              </div>
            </div></form
        ></ng-container>
      </div>
    </div>
  </div>
</div>
